import { render } from "./SmGroup.vue?vue&type=template&id=65295439&scoped=true"
import script from "./SmGroup.vue?vue&type=script&lang=js"
export * from "./SmGroup.vue?vue&type=script&lang=js"

import "./SmGroup.vue?vue&type=style&index=0&id=65295439&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65295439"]])

export default __exports__